import { UserAction } from 'modules/application/misc/UndoRedoService';
export class DeleteStateIAction extends UserAction {
    static $inject = ['properties'];
    constructor(properties) {
        super();
        Object.assign(this, properties);
    }
}
